import classNames from "classnames"

import { Psychologist } from "utils/interfaces"
import { Price, Discount } from "components"

interface Props {
    psy: Psychologist
    priceClassName?: string
    discountClassName?: string
}

export function PsychologistPrice({ psy, priceClassName, discountClassName }: Props) {
    return (
        <>
            <Price className={priceClassName} psy={psy} />{" "}
            <Discount
                className={classNames(
                    `${
                        discountClassName ? discountClassName : ""
                    } profile__psychologist-discount price-and-discount__discount-strikethrough`,
                    {}
                )}
                psy={psy}
            />
        </>
    )
}
